<template>
  <div class="page_search_area">
    <el-form :inline="true">
      <el-form-item label="年度筛选：" class="search_item_area">
        <el-select v-model="searchData.year" placeholder="请选择">
          <el-option
            v-for="item in arrYears"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="月度筛选：" class="search_item_area">
        <el-select v-model="searchData.month" placeholder="请选择">
          <el-option
            v-for="item in arrMonths"
            :key="item"
            :label="item + '月'"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="search_item_area">
        <el-button
          class="search_btn"
          type="primary"
          @click="btnSearchClick"
          :loading="searchingCount > 0"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-button class="btn_out" @click="btnDownloadClick" v-if="pms.download">
      <div class="btn_content">
        <div class="icon-download"></div>
        <div class="text_download">导出</div>
      </div>
    </el-button>

    <!-- 导出 -->
    <el-dialog
      title="导出表格数据"
      :visible.sync="showDownloadDialog"
      width="61rem"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
      class="dialog_statistics_download"
    >
      <div class="cell">
        日期：
        <el-date-picker
          v-model="downloadData.dateRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日"
          :picker-options="datePickerOptions"
        >
        </el-date-picker>
      </div>
      <div class="cell">
        <el-checkbox
          v-model="downloadData.space"
          label="纪念堂来源统计"
        ></el-checkbox>
        <el-checkbox
          v-model="downloadData.product"
          label="产品统计"
        ></el-checkbox>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showDownloadDialog = false">取消</el-button>
        <el-button type="primary" @click="btnDoneDownloadClick"
          >确定导出</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixins from "./Mixins";
export default {
  mixins: [mixins],
  data() {
    return {
      pms: {
        download: false,
      },
      arrYears: [],
      arrMonths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      showDownloadDialog: false,
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2021-01-01")
          );
        },
      },
      lastDownloadTime: 0,
    };
  },
  computed: {
    searchData() {
      return this.Statistics.searchData;
    },
    searchingCount() {
      return this.Statistics.searchingCount;
    },
    downloadData() {
      return this.Statistics.downloadData;
    },
  },
  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms.download = pms["10100"].check;
  },
  mounted() {
    let dateNow = new Date();
    let year = dateNow.getFullYear();
    let month = dateNow.getMonth() + 1;
    this.setSearchData_M({
      year: year,
      month: month,
    });
    this.arrYears = [];
    do {
      this.arrYears.push({ label: `${year}年`, value: year });
      year = year - 1;
    } while (year >= 2021);
    this.btnSearchClick();
  },
  methods: {
    btnSearchClick() {
      this.searchTable_A();
    },
    btnDownloadClick() {
      this.SETOPTIONS({
        downloadData: {
          dateRange: [],
          space: false,
          product: false,
        },
      });
      this.showDownloadDialog = true;
      // console.log()
    },
    handleDialogClose() {
      this.showDownloadDialog = false;
      this.SETOPTIONS({
        downloadData: {
          dateRange: [],
          space: false,
          product: false,
        },
      });
    },
    btnDoneDownloadClick() {
      if (
        !this.downloadData.dateRange ||
        this.downloadData.dateRange.length == 0
      ) {
        this.$Message.error("请选择日期");
        return;
      }
      if (!this.downloadData.space && !this.downloadData.product) {
        this.$Message.error("至少选择一个模块导出");
        return;
      }
      this.downloadStatistics_A();
    },
    // debounce(fnName, time) {
    //   let timeout = null;
    //   return function () {
    //     if (timeout) {
    //       clearTimeout(timeout);
    //     }
    //     timeout = setTimeout(() => {
    //       this[fnName]();
    //     }, time);
    //   };
    // },
  },
};
</script>

<style lang="stylus" scoped>
.page_search_area {
  height: 80px;

  .btn_out {
    background-color: #F66915;
    width: 100px;
    height: 40px;
    float: right;
    margin-top: -60px;
    margin-right: 30px;
    color: #fff;
    padding: 0 20px;
    border: 0;

    .btn_content {
      display: flex;
      align-items: center;
    }

    .icon-download {
      background: url('~@/assets/images/Statistics/icon_out.png') no-repeat;
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 10px;
    }

    .text_download {
      display: inline-block;
    }
  }
}

.dialog_statistics_download {
  .cell {
    height: 40px;
    line-height: 40px;
    padding-left: 80px;
    text-align: left;
  }

  .cell:nth-child(2) {
    height: 80px;
    line-height: 80px;
  }

  .el-button {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/Statistics/components/statisticsSearch.vue